import $ from 'jquery'

export default class {
  constructor(table, wrapper) {
    this.table = table
    this.wrapper = wrapper

    if (!this.wrapper) {
      this.wrapper = $('<div/>')
      this.wrapper.insertBefore(this.table)
      this.wrapper.append(this.table)
    }
    this.tfoot = this.table.find('tfoot')

    this.buildFloat()
    $(window).scroll(() => this.buildFloat())
    $(window).resize(() => this.buildFloat())
    this.wrapper.scroll(() => this.buildFloat())
  }

  buildFloat() {
    if (
      this.tfoot.offset().top + this.tfoot.height() > $(window).scrollTop() + $(window).height() &&
      this.table.offset().top + this.tfoot.height() < $(window).scrollTop() + $(window).height()
    ) {
      this.refreshFloat()
    } else {
      if (this.float) this.float.remove()
      this.float = null
    }
  }

  refreshFloat() {
    if (!this.float) {
      let $tableClone = (this.floatTable = this.table.clone())
      $tableClone.css({ left: this.table.offset().left - this.wrapper.offset().left })
      $tableClone.find(':not(tfoot,tfoot *)').css({ visible: 'hidden' })
      $tableClone.css({
        margin: 0,
        padding: 0,
        position: 'relative',
        top: this.tfoot.height() - this.table.height()
      })
      this.float = $('<div/>')
      this.float.append($tableClone)
      this.float.insertAfter(this.table)
    }

    this.float.css({
      position: 'fixed',
      height: this.tfoot.outerHeight() + 1,
      overflow: 'hidden',
      bottom: 0,
      left: this.wrapper.offset().left - $(window).scrollLeft(),
      width: this.wrapper.width()
    })
    this.floatTable.css({ left: this.table.offset().left - this.wrapper.offset().left })
  }

  refresh() {
    if (this.floatTable) this.floatTable.remove()
    if (this.float) this.float.remove()
    this.float = this.floatTable = null
    this.buildFloat()
  }
}
